import axios from 'axios';
import { API_BASE_URL } from 'constants/ApiConstant';

export default () => {
  axios.defaults.baseURL = API_BASE_URL
  axios.interceptors.request.use(
    config => {
      config.headers.Authorization = `Bearer ${localStorage.getItem('AUTH_TOKEN')}`;
      const locationId = localStorage.getItem('LOCATION_ID')
      const appUserId = localStorage.getItem('APP_USER_ID')
      if (locationId) {
        config.headers.LocationId = `${localStorage.getItem('LOCATION_ID')}`;
      }
      if (appUserId) {
        config.headers.AppUserId = `${localStorage.getItem('APP_USER_ID')}`;
      }
      return config;
    },
    err => Promise.reject(err)
    );
  // axios.interceptors.request.use(
  //   (config) => {
  //     const axiosConfig = config;
  //     const accessToken = localStorage.getItem('accessToken');

  //     if (accessToken) {
  //       axiosConfig.headers.Authorization = `Bearer ${accessToken}`;
  //     }

  //     return axiosConfig;
  //   },
  //   (error) => {
  //     Promise.reject(error);
  //   },
  // );

  // axios.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     const originalRequest = error.config;
  //     const refreshToken = localStorage.getItem('accessToken');

  //     if (!error.response) {
  //       return Promise.reject(error);
  //     }

  //     if (error.response.status === 401) {
  //       if (error.response.data && error.response.data.message === 'Unauthenticated.' && refreshToken && !originalRequest.retry) {
  //         originalRequest.retry = true;

  //         return axios.post(process.env.REACT_APP_AUTH_REFRESH).then((res) => {
  //           if (res.status === 200) {
  //             localStorage.setItem('accessToken', res.data.accessToken);
  //             return axios(originalRequest);
  //           }

  //           return Promise.reject(error);
  //         }).catch(() => {
  //           window.location.href = '/login';
  //         });
  //       }
  //     } else if (error.response.status === 500) {
  //       console.error(error.response.data.message);
  //     } else if (error.response.status === 404) {
  //       console.error('Invalid API');
  //     }

  //     return Promise.reject(error);
  //   },
  // );


};
